import React from 'react';
import { SvgIcon } from '@mui/material';

export default function Connector({
  fill = '#c9cdd9',
  width = '25',
  height = '25',
  ...props
}) {
  return (
    <SvgIcon
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      {...props}
    >
      <g transform="translate(-825.632 -405.029)">
        <rect
          width="25"
          height="25"
          transform="translate(825.632 405.029)"
          fill="none"
        />
        <path
          d="M848.538,417.378a1.758,1.758,0,0,0-3.318-.507h-1.232a5.948,5.948,0,0,0-.906-2.507l2.3-.005a.691.691,0,0,0,.692-.692V411.46a1.757,1.757,0,1,0-1.385,0v1.519l-2.845.007a5.952,5.952,0,0,0-3.026-1.285V409.39a1.755,1.755,0,0,0,1.028-1.96,1.756,1.756,0,1,0-2.414,1.96V411.7a5.959,5.959,0,0,0-3.07,1.292l-2.815-.008v-1.539a1.779,1.779,0,0,0,.8-.624,1.753,1.753,0,0,0,.3-1.324,1.779,1.779,0,0,0-3.2-.725,1.769,1.769,0,0,0,.712,2.637v2.27a.7.7,0,0,0,.7.7h2.273a5.951,5.951,0,0,0-.9,2.5h-1.175a1.758,1.758,0,0,0-3.1-.121,1.748,1.748,0,0,0,.63,2.4,1.761,1.761,0,0,0,2.529-.892h1.113a5.942,5.942,0,0,0,.9,2.5l-2.3.009a.694.694,0,0,0-.689.692v2.156a1.76,1.76,0,0,0-.761.672,1.757,1.757,0,1,0,2.147-.707v-1.434l2.838-.011a5.959,5.959,0,0,0,3.074,1.3v2.236a1.75,1.75,0,0,0,.692,3.36,1.707,1.707,0,0,0,.352-.035,1.75,1.75,0,0,0,.341-3.325v-2.242a5.96,5.96,0,0,0,3.019-1.277h2.852V423.6a1.752,1.752,0,1,0,2.158,2.575,1.751,1.751,0,0,0-.772-2.575v-2.139a.693.693,0,0,0-.693-.692h-2.3q.08-.123.156-.252a.47.47,0,0,0,.038-.1,5.316,5.316,0,0,0,.427-.948l.036-.081a5.83,5.83,0,0,0,.249-1.137h1.171a1.758,1.758,0,0,0,3.053.42A1.733,1.733,0,0,0,848.538,417.378Zm-1.366.258a.371.371,0,1,1-.371-.369A.369.369,0,0,1,847.172,417.636Zm-15.934,7.573a.37.37,0,1,1-.461-.357.714.714,0,0,0,.154-.006A.373.373,0,0,1,831.238,425.209ZM845.01,409.85a.37.37,0,1,1,.37.368A.369.369,0,0,1,845.01,409.85Zm-6.885-2.438a.372.372,0,0,1,.262.108.365.365,0,0,1,.108.26.37.37,0,0,1-.741,0,.37.37,0,0,1,.371-.367Zm-.083,19.508a.752.752,0,0,0,.164,0,.366.366,0,0,1,.289.36.384.384,0,0,1-.633.258.365.365,0,0,1-.108-.26A.362.362,0,0,1,838.042,426.92Zm3.3-5.749-.236-.217a4.59,4.59,0,0,1-6.01,0,.878.878,0,0,0-.074-.068,4.505,4.505,0,0,1-.263-6.38c.085-.091.172-.178.267-.266.053-.05.053-.05.126-.111a4.58,4.58,0,0,1,5.878-.029.657.657,0,0,0,.146.14,4.524,4.524,0,0,1,1.267,4.658l-.417.946a4.55,4.55,0,0,1-.9,1.091l.212.239Zm-10.071-11.377a.383.383,0,0,1-.767,0,.389.389,0,0,1,.383-.381A.383.383,0,0,1,831.274,409.794Zm-1.441,7.85a.37.37,0,1,1-.37-.375A.38.38,0,0,1,829.833,417.644Zm15.177,7.565a.37.37,0,1,1,.371.368A.37.37,0,0,1,845.01,425.209Z"
          fill={fill}
        />
        <path
          d="M838.1,414.427a3.06,3.06,0,1,0,3.061,3.06A3.064,3.064,0,0,0,838.1,414.427Z"
          fill={fill}
        />
      </g>
    </SvgIcon>
  );
}
